import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const FEATURE_BACKGROUND = '8a3df10f094f5986e0c6e5443c145718.png'
const PREMIUM_LOGO = 'f6e7e1aa2569b829dd11d772c037aa1d.png'
const ROTATING_ARROWS = 'ffaceca2486210a417960bdea07b8839.png'
const SOURCE_CONNECTOR = 'e6411ca2d1ad06208252a08773ad403e.png'
const VIP_PYRAMID = '05bf543eba712800adb8f70085e97a6f.png'
const ONLINE_BOOKING_ICON = '3525ef882331ce434cfc9e2d4a495770.png'
const AI_ENGINE_ICON = '188f59983b7e58d3c3e3554e0c3b1cda.png'
const OUTCOME_ARROW = '2b09fe21820598621a7eb5e52f18e5b0.png'

const EXPERIENCE_SOURCES = [
  { id: 'airlines', icon: preFixImgUrl('247b52995ddbf207936ce3cd8ee6acb5.png'), labelKey: 'vip.features.sources.airlines' },
  { id: 'creditCards', icon: preFixImgUrl('2b8a67600ba61b08d02d4d553ae4de6e.png'), labelKey: 'vip.features.sources.creditCards' },
  { id: 'ota', icon: preFixImgUrl('0ca24c0efc7d84f1598e3035b8548723.png'), labelKey: 'vip.features.sources.ota' },
] as const

const VIP_EXPERIENCES = [
  { id: 'personalShopping', icon: preFixImgUrl('41fb003a330dc34bb513781c2759165c.png'), labelKey: 'vip.features.experiences.personalShopping' },
  { id: 'luxuryHotels', icon: preFixImgUrl('37027c09cd2e25dd9e39246b92720a8a.png'), labelKey: 'vip.features.experiences.luxuryHotels' },
  { id: 'privateTransfers', icon: preFixImgUrl('3d72466e5dbe5334652200366fb4fc09.png'), labelKey: 'vip.features.experiences.privateTransfers' },
  { id: 'fineDining', icon: preFixImgUrl('76e68b4d8ca3d8c7a28e7ec16f25b0ef.png'), labelKey: 'vip.features.experiences.fineDining' },
  { id: 'fastTrack', icon: preFixImgUrl('09e46f1689b6812974f98a05b57fcb64.png'), labelKey: 'vip.features.experiences.fastTrack' },
  { id: 'vipLounge', icon: preFixImgUrl('37a9b251f1c906ac4502a606c8a7c01d.png'), labelKey: 'vip.features.experiences.vipLounge' },
] as const

const SourceTitle = () => (
  <LangText
    lngKey="vip.features.createExperience"
    className="absolute left-[235px] top-[-30px] z-[3] flex h-[60px] w-[300px] -translate-x-1/2 items-center justify-center rounded-full bg-primary px-[30px] font-smiley-sans text-[30px] font-medium leading-[42px] text-white"
  />
)

const SourcePanel = () => (
  <div className="absolute left-0 top-0 flex h-[400px] w-[470px] flex-col items-center justify-center pt-[20px]">
    <div className="flex items-center justify-center gap-[28px]">
      {EXPERIENCE_SOURCES.map((item) => (
        <div
          key={item.id}
          className="group flex h-[104px] w-[104px] flex-col items-center justify-center rounded-[10px] bg-white/75 text-center shadow-[0_5px_16px_rgba(50,139,248,0.06)]"
        >
          <img src={item.icon} alt="" className="h-[54px] w-[54px] object-contain" draggable={false} aria-hidden />
          <LangText lngKey={item.labelKey} className="mt-[4px] whitespace-nowrap text-[16px] leading-[22px] text-[#000]" />
        </div>
      ))}
    </div>

    <img
      src={preFixImgUrl(SOURCE_CONNECTOR)}
      alt=""
      className="h-[42px] w-[265px] shrink-0 object-fill"
      draggable={false}
      aria-hidden
    />

    <LangText
      lngKey="vip.features.premiumMember"
      className="whitespace-nowrap mt-[4px] text-[16px] leading-[22px] text-[#000]"
    />
    <img
      src={preFixImgUrl(VIP_PYRAMID)}
      alt=""
      className="mt-[4px] h-auto w-[204px] shrink-0 object-contain"
      draggable={false}
      aria-hidden
    />
  </div>
)

const ExperiencePanel = () => (
  <div className="absolute right-0 top-0 h-[400px] w-[470px]">
    <div className="absolute left-[48px] top-[80px] grid w-[374px] grid-cols-3 gap-x-[20px] gap-y-[20px]">
      {VIP_EXPERIENCES.map((item) => (
        <div
          key={item.id}
          className="group flex h-[104px] flex-col items-center justify-center rounded-[10px] bg-white/75 text-center shadow-[0_5px_16px_rgba(50,139,248,0.06)]"
        >
          <img src={item.icon} alt="" className="h-[54px] w-[54px] object-contain" draggable={false} aria-hidden />
          <LangText lngKey={item.labelKey} className="mt-[4px] text-[15px] leading-[21px] text-[#222]" />
        </div>
      ))}
    </div>
  </div>
)

const ExperienceTitle = () => (
  <LangText
    lngKey="vip.features.provideExperience"
    className="absolute right-[235px] top-[-30px] z-[3] flex h-[60px] w-[300px] translate-x-1/2 items-center justify-center rounded-full bg-primary px-[30px] font-smiley-sans text-[30px] font-medium leading-[42px] text-white"
  />
)

const PremiumCore = () => (
  <div className="absolute left-1/2 top-0 h-[400px] w-[320px] -translate-x-1/2">
    <div className="absolute left-1/2 top-[-38px] h-[483px] w-[263px] -translate-x-1/2">
      <img
        src={preFixImgUrl(ROTATING_ARROWS)}
        alt=""
        className="h-[483px] w-[263px] object-contain motion-safe:animate-[vip-feature-arrow-spin_12s_linear_infinite]"
        aria-hidden
      />
    </div>

    <img
      src={preFixImgUrl(PREMIUM_LOGO)}
      alt="BilionPass Premium"
      className="absolute left-1/2 top-[82px] h-[236px] w-[236px] -translate-x-1/2 object-contain"
      draggable={false}
    />
  </div>
)

const FeatureTop = () => (
  <div className="flex w-full pl-[470px] items-start justify-start">
    <div className="flex items-center gap-[6px] text-[18px] leading-[26px] text-[#222]">
      <img
        src={preFixImgUrl(ONLINE_BOOKING_ICON)}
        alt=""
        className="h-[80px] w-[80px] shrink-0 object-contain"
        draggable={false}
        aria-hidden
      />
      <LangText className="text-[20px] leading-[30px] text-[#000]" lngKey="vip.features.onlineBooking" />
    </div>
  </div>
)

const FeatureBottom = () => (
  <div className="flex pl-[470px] items-start justify-start pt-[14px]">
    <div className="flex items-start gap-[6px]">
      <img
        src={preFixImgUrl(AI_ENGINE_ICON)}
        alt=""
        className="h-[64px] w-[64px] shrink-0 object-contain"
        draggable={false}
        aria-hidden
      />
      <LangText
        lngKey="vip.features.aiDescription"
        className="whitespace-pre-line text-[20px] leading-[30px] text-[#000]"
      />
    </div>
  </div>
)

const ServiceFeatures = () => (
  <section className="w-full bg-white py-[96px]">
    <div className="mx-auto w-[1200px]">
      <div className="flex flex-col items-center">
        <LangText lngKey="vip.features.title" className="text-[36px] font-bold leading-[50px] text-[#000]" />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-primary" />
      </div>

      <div className="mt-[48px] w-full">
        <FeatureTop />

        <div className="relative h-[400px] w-full overflow-visible">
          <img
            src={preFixImgUrl(FEATURE_BACKGROUND)}
            alt=""
            className="absolute inset-0 h-[400px] w-[1200px] object-fill"
            aria-hidden
          />
          <SourceTitle />
          <ExperienceTitle />
          <SourcePanel />
          <PremiumCore />
          <ExperiencePanel />
        </div>

        <FeatureBottom />
      </div>

      <div className="mt-[20px] flex flex-col items-center">
        <img
          src={preFixImgUrl(OUTCOME_ARROW)}
          alt=""
          className="h-[260px] w-[436px] object-contain motion-safe:animate-[vip-outcome-arrow-float_1.6s_ease-in-out_infinite]"
          draggable={false}
          aria-hidden
        />
        <LangText
          lngKey="vip.features.outcome"
          className="mt-[30px] flex h-[82px] items-center justify-center rounded-full border-[6px] border-[#DCEBFF] bg-primary px-[38px] font-smiley-sans text-[32px] font-medium leading-[40px] text-white shadow-[0_6px_16px_rgba(50,139,248,0.16)]"
        />
      </div>
    </div>

    <style>
      {`
        @keyframes vip-feature-arrow-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes vip-outcome-arrow-float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(16px); }
        }
      `}
    </style>
  </section>
)

export default ServiceFeatures
